//natives
import React from 'react';
import Button from '@material-ui/core/Button';
import AddIcon from '@material-ui/icons/Add';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';

const useStyles = makeStyles(theme => ({

}));

export default function (props) {
    const classes = useStyles();
    
    return (
        <div className={"container"}>
            <Grid
                container
                direction="row"                
                alignItems="baseline"
            >
                <Button 
                    color="primary"
                    variant="contained"
                    aria-label="add"                    
                    onClick={(e) => {props.props.router.push('/'+props.props.route.title+'s-ae')}}
                >
                    <AddIcon /> Adicionar
                </Button>
            </Grid>
        </div>
    );

}